import { createTheme } from "@mui/material";

const COLORS = {
  light: {
    primary: "#028A0F",
    secondary: "#D97014",
    background: "#ffffff",
    paper: "#f5f5f5",
    textPrimary: "#111111",
    textSecondary: "#585858",
    login: {
      overlay: "rgba(17, 17, 17, 0.58)",
      cardBackground: "rgba(255, 255, 255, 0.92)",
      cardBorder: "rgba(241, 115, 5, 0.97)",
      title: "#D97014",
      subtitle: "#585858",
      inputBackground: "rgba(245, 245, 245, 0.96)",
      buttonText: "#111111",
      error: "#d33131",
      shadow: "0 22px 55px rgba(17, 17, 17, 0.30)",
    },
  },
  dark: {
    primary: "#D0EA15",
    secondary: "#D97014",
    background: "#111111",
    paper: "#1b1b1b",
    textPrimary: "#ffffff",
    textSecondary: "#d6d6d6",
    login: {
      overlay: "rgba(17, 17, 17, 0.78)",
      cardBackground: "#585858",
      cardBorder: "#D97014",
      title: "#D97014",
      subtitle: "#d6d6d6",
      inputBackground: "rgba(88, 88, 88, 0.92)",
      buttonText: "#111111",
      error: "#ff8f8f",
      shadow: "0 24px 60px rgba(0, 0, 0, 0.58)",
    },
  },
};

export const createAppTheme = (mode = "light") => {
  const currentMode = mode === "dark" ? "dark" : "light";
  const palette = COLORS[currentMode];

  return createTheme({
    palette: {
      mode: currentMode,
      primary: {
        main: palette.primary,
      },
      secondary: {
        main: palette.secondary,
      },
      background: {
        default: palette.background,
        paper: palette.paper,
      },
      text: {
        primary: palette.textPrimary,
        secondary: palette.textSecondary,
      },
      error: {
        main: palette.login.error,
      },
    },
    custom: {
      login: palette.login,
    },
    shape: {
      borderRadius: 14,
    },
  });
};

const theme = createAppTheme("light");
export default theme;
